var   KEYS  = require('../../keys/Keys');
var   AXIOS = require('axios');

export {CreateProductAsync as InvokeAsync , CreateProductSync as InvokeSync}

async function CreateProductAsync(LoginToken,ProductUUID,BootUUID,ProductName,LinkedBrand)
{
    var CreateProductPromise = new Promise((resolve, reject) => {
        CreateProductSync(LoginToken,ProductUUID,BootUUID,ProductName,LinkedBrand,(response,error) => {
            if (error) {  
                try{ 
                    return reject(error.response.data.message);
                }catch(ex){
                    return reject('Unknown error');
                }
            }
            if(response.status==='fails'){
                reject(response.error);
            }else{
                resolve(null);
            }
        });
    });

    return await CreateProductPromise;
}

function CreateProductSync(LoginToken,ProductUUID,BootUUID,ProductName,LinkedBrand,Callback)
{
    AXIOS({
        headers:{
            'Content-Type': 'application/json',
            'x-api-key'   : KEYS.AWS_XKEY,
        },
        method : 'post',
        url    :'/Admin/CreateProduct',                
        data  : {
            AppID       :KEYS.AWS_APPID,
            ProductName :ProductName ,
            ProductUUID :ProductUUID ,
            BootUUID    :BootUUID    ,
            LinkedBrand :LinkedBrand ,
            LoginToken  :LoginToken             
        },                                
    })
    .then((response)=>{
        Callback(response.data,null);
    },(error) => { 
        Callback(null,error + ' ');
    });
}
